/**
 * Simplified Chinese (CNY + SGD + USD) mock entity data for the marketing-
 * site mockups. Row shapes mirror the app's API rows (see
 * shared-site-web/screens/*.js), so the real column definitions and
 * table components can render them.
 */

/** @type {Array<import('../../mock-data.js').MockAccount>} */
export const MOCK_ACCOUNTS_ZH_CN = [
	{ id: 'acc-checking', name: '常青银行', accountType: 'Bank Account', currency: 'CNY', currencySymbol: '\u00A5', currencyDecimalPlaces: 2, balance: 28940, principal: null, updatedAt: '2026-08-08' },
	{ id: 'acc-savings', name: '定期存款', accountType: 'Bank Account', currency: 'SGD', currencySymbol: 'S$', currencyDecimalPlaces: 2, balance: 28846, principal: null, updatedAt: '2026-08-08' },
	{ id: 'acc-broker', name: '增长型基金', accountType: 'Investment Account', currency: 'SGD', currencySymbol: 'S$', currencyDecimalPlaces: 2, balance: 139038, principal: 147068.37, updatedAt: '2026-08-08' },
	{ id: 'acc-pension', name: '公积金', accountType: 'Pension', currency: 'SGD', currencySymbol: 'S$', currencyDecimalPlaces: 2, balance: 53846, principal: null, updatedAt: '2026-08-08' },
	{ id: 'acc-property', name: '我的家', accountType: 'Real Estate', currency: 'CNY', currencySymbol: '\u00A5', currencyDecimalPlaces: 2, balance: 3500000, principal: 2800000, updatedAt: '2026-08-08' },
	{ id: 'acc-flight', name: '飞行里程', accountType: 'Points/Miles', currency: 'MILES', currencySymbol: '\u2708', currencyDecimalPlaces: 0, balance: 84620, principal: null, updatedAt: '2026-08-08' },
	{ id: 'acc-credit', name: '返利卡', accountType: 'Credit Card', currency: 'CNY', currencySymbol: '\u00A5', currencyDecimalPlaces: 2, balance: 8420, principal: null, updatedAt: '2026-08-08' },
	{ id: 'acc-joke', name: '美股组合', accountType: 'Investment Account', currency: 'USD', currencySymbol: '$', currencyDecimalPlaces: 2, balance: 27778, principal: 15262.52, updatedAt: '2026-08-08' },
];

/**
 * Custom currencies (CNY base) for the currencies use case. MILES and HP
 * carry a manual rate so the currency table shows the manual marker "(M)".
 * @type {Array<import('../../mock-data.js').MockCurrency>}
 */
export const MOCK_CURRENCIES_ZH_CN = [
	{ code: 'CNY', isCustom: 0, name: '人民币', symbol: '\u00A5', decimalPlaces: 2, isBase: 1, rate: 1, manualRate: null },
	{ code: 'SGD', isCustom: 0, name: '新加坡元', symbol: 'S$', decimalPlaces: 2, isBase: 0, rate: 5.2, manualRate: null },
	{ code: 'USD', isCustom: 0, name: '美元', symbol: '$', decimalPlaces: 2, isBase: 0, rate: 7.2, manualRate: null },
	{ code: 'MILES', isCustom: 1, name: '飞行里程', symbol: '\u2708', decimalPlaces: 0, isBase: 0, rate: 0.15, manualRate: 0.15 },
	{ code: 'HP', isCustom: 1, name: '酒店积分', symbol: 'P', decimalPlaces: 0, isBase: 0, rate: 0.08, manualRate: 0.08 },
	{ code: 'SM', isCustom: 1, name: '状态里程', symbol: 'SM', decimalPlaces: 0, isBase: 0, rate: 0, manualRate: 0 },
];

/**
 * Everyday currencies (CNY base) with auto-fetched rates for the
 * multi-currency use case.
 * @type {Array<import('../../mock-data.js').MockCurrency>}
 */
export const MOCK_RATES_ZH_CN = [
	{ code: 'CNY', isCustom: 0, name: '人民币', symbol: '\u00A5', decimalPlaces: 2, isBase: 1, rate: 1, manualRate: null },
	{ code: 'SGD', isCustom: 0, name: '新加坡元', symbol: 'S$', decimalPlaces: 2, isBase: 0, rate: 5.2, manualRate: null },
	{ code: 'USD', isCustom: 0, name: '美元', symbol: '$', decimalPlaces: 2, isBase: 0, rate: 7.2, manualRate: null },
	{ code: 'GBP', isCustom: 0, name: '英镑', symbol: '\u00A3', decimalPlaces: 2, isBase: 0, rate: 9.15, manualRate: null },
	{ code: 'EUR', isCustom: 0, name: '欧元', symbol: '\u20AC', decimalPlaces: 2, isBase: 0, rate: 7.85, manualRate: null },
];
